import type { StrumPattern } from '@/types/training';

/**
 * Eighth-note grid: `eighth` 0..7 maps to "1 & 2 & 3 & 4 &".
 * Down strokes land on numbers, up strokes on the "&" — that is how a hand
 * moving continuously in eighths works, and it is why the direction is an
 * instruction rather than something we try to hear (see docs/research.md §3).
 */
export const STRUM_PATTERNS: StrumPattern[] = [
  {
    id: 'downs',
    nameRu: 'Четыре вниз',
    difficulty: 1,
    steps: [
      { eighth: 0, direction: 'down' },
      { eighth: 2, direction: 'down' },
      { eighth: 4, direction: 'down' },
      { eighth: 6, direction: 'down' },
    ],
  },
  {
    id: 'down-up',
    nameRu: 'Вниз-вверх',
    difficulty: 1,
    steps: [
      { eighth: 0, direction: 'down' },
      { eighth: 1, direction: 'up' },
      { eighth: 2, direction: 'down' },
      { eighth: 3, direction: 'up' },
      { eighth: 4, direction: 'down' },
      { eighth: 5, direction: 'up' },
      { eighth: 6, direction: 'down' },
      { eighth: 7, direction: 'up' },
    ],
  },
  {
    id: 'classic-six',
    nameRu: 'Шестёрка',
    difficulty: 2,
    steps: [
      { eighth: 0, direction: 'down' },
      { eighth: 2, direction: 'down' },
      { eighth: 3, direction: 'up' },
      { eighth: 5, direction: 'up' },
      { eighth: 6, direction: 'down' },
      { eighth: 7, direction: 'up' },
    ],
  },
  {
    id: 'skip-three',
    nameRu: 'С пропуском',
    difficulty: 3,
    steps: [
      { eighth: 0, direction: 'down' },
      { eighth: 1, direction: 'up' },
      { eighth: 3, direction: 'up' },
      { eighth: 4, direction: 'down' },
      { eighth: 5, direction: 'up' },
      { eighth: 7, direction: 'up' },
    ],
  },
];

export function getStrumPattern(id: string): StrumPattern | undefined {
  return STRUM_PATTERNS.find((p) => p.id === id);
}

/** Human-readable count for a bar of eighths: 1 и 2 и 3 и 4 и. */
export const EIGHTH_LABELS = ['1', 'и', '2', 'и', '3', 'и', '4', 'и'] as const;
